module.exports = __webpack_public_path__ + "static/media/clock-icon-gray.225692d5.svg";